import * as React from 'react';

const HomePageArrowRight = ({
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.3032 8.5L2.81787 16.9854L0.696777 14.8643L7.06104 8.5L0.696777 2.13574L2.81787 0.0146484L11.3032 8.5Z" fill="black" />
  </svg>
);

export default HomePageArrowRight;
